import {
  dogService
} from '../_services';
import {
  isEqual
} from 'lodash';

// importamos las traducciones para gestionar los avisos
import i18n from '../i18n.js';

const dogBooksLocal = JSON.parse(localStorage.getItem('dogBooks'));
const dogBreedsLocal = JSON.parse(localStorage.getItem('dogBreeds'));

const state = {
  dogBreeds: dogBreedsLocal ? dogBreedsLocal : null,
  dogBooks: dogBooksLocal ? dogBooksLocal : null,
  loading: false,
  dogsData: null,
  error: null,
  currentEditDog: null
}

const actions = {

  getDogBooks({
    commit
  }) {
    commit('statusLoading', true);
    dogService.getDogBooks()
      .then(
        books => {
          commit('getBooksSuccess', books)
        },
        error => commit('getBooksFailure', error)
      );

  },

  getDogBreeds({
    commit
  }) {

    commit('statusLoading', true);

    dogService.getDogBreeds()
      .then(response => {
          commit('getDogBreedsOk', response);
        },
        error => commit('getDogBreedsKo', error)
      )
  },

  createUserDog({
    dispatch,
    commit
  }, objDog) {

    commit('statusLoading', true);

    return new Promise((resolve, reject) => {

      dogService.createUserDog(objDog)
        .then(
          data => {
            dispatch('notifier/success', i18n.t('notifier_created_dog_ok'), {
              root: true
            });
            commit('createDogOk', data);
            let userId = JSON.parse(localStorage.getItem('user'));
            dispatch('account/refreshUserData', userId['id'], {
              root: true
            });
            return resolve(data.data);
          },
          error => {
            dispatch('notifier/error', error, {
              root: true
            });
            console.log(error)
            return reject(false);
            commit('createDogKo', error);
          }
        )

    })



  },
  /* 23/04/2020 nuevo sistema de propietarios y copropietarios  */
  updateUserDogNew({
    commit,
    dispatch
  }, datos) {

    return new Promise((resolve, reject) => {

      dogService.updateUserDog(datos).then(res => {

        dispatch('notifier/success', i18n.t('notifier_updated_dog_ok'), {
          root: true
        });
        return resolve(res.data);

      }, error => {

        dispatch('notifier/error', error, {
          root: true
        })
        return reject(error);

      })
    })

  },

  updateUserDog({
    commit,
    dispatch
  }, objDog) {

    const silent = !!(objDog.silent === true);


    if (!silent) commit('statusLoading', true);

    dogService.updateUserDog(objDog)
      .then(
        data => {
          commit('updateDogOk', data);
          if (!silent) {
            dispatch('notifier/success', i18n.t('notifier_updated_dog_ok'), {
              root: true
            })
          }
          let userId = JSON.parse(localStorage.getItem('user'))
          dispatch('account/refreshUserData', userId['id'], {
            root: true
          });
        },
        error => {
          commit('updateDogKo', error);
          dispatch('notifier/error', error, {
            root: true
          })
        }

      )
  },

  getUserDogById({
    commit
  }, data) {

    const dogId = data.dogId;
    const silent = !!(data.silent === true);

    console.log("silent es ", silent)
    if (!silent) {
      commit('statusLoading', true);
    }

    const promesa = new Promise((resolve, reject) => {
      dogService.getUserDog(dogId)
        .then(
          data => {
            commit('getUserDogByIdOk', data.data);
            return resolve(data.data);
          },
          error => {
            commit('getUserDogByIdKo', error);
            reject(error);
            /* dispatch('notifier/error', error, {
              root: true
            }); */
          }
        )
    });

    return promesa;

  },

  deleteUserDog({
    commit
  }, userDog) {
    console.log('Desde eliminar perro.... está pendiente')

  },
  /* FUNCION PARAR BUSCAR UN PERRO POR SU CHIP */
  stBuscarPerroChip({
    commit
  }, chip) {

    return new Promise((resolve, reject) => {
      dogService.stBuscarPerroChip(chip).then(
        res => resolve(res.data),
        error => reject(false))
    })

  },



  /* FUNCIONES PARA LOS CRIADORES */
  callCrearCriador({
    commit
  }, datos) {
    const prm = new Promise((resolve, reject) => {
      dogService.createCriador(datos)
        .then(res => {
            resolve(res);
          },
          error => {
            reject(error);
          });
    })

    return prm;
  },
  callActualizarCriador({
    commit
  }, datos) {
    const prm = new Promise((resolve, reject) => {
      dogService.updateCriador(datos)
        .then(res => {
            resolve(res);
          },
          error => {
            reject(error);
          });
    })

    return prm;

  },
  callEliminarCriador({
    commit
  }, id) {
    const prm = new Promise((resolve, reject) => {
      dogService.deleteCriador(id)
        .then(res => {
            resolve(res);
          },
          error => {
            reject(error);
          });
    })

    return prm;

  },
  /* FUNCIONES PARA LOS COPROPIETARIOS */
  callCrearCopropietario({
    commit
  }, datos) {
    const prm = new Promise((resolve, reject) => {
      dogService.createCopropietario(datos)
        .then(res => {
            resolve(res);
          },
          error => {
            reject(error);
          });
    })

    return prm;
  },
  callActualizarCopropietario({
    commit
  }, datos) {
    const prm = new Promise((resolve, reject) => {
      dogService.updateCopropietario(datos)
        .then(res => {
            resolve(res);
          },
          error => {
            reject(error);
          });
    })

    return prm;

  },
  callEliminarCopropietario({
    commit
  }, id) {
    const prm = new Promise((resolve, reject) => {
      dogService.deleteCopropietario(id)
        .then(res => {
            resolve(res);
          },
          error => {
            reject(error);
          });
    })
    return prm;
  },

  /* FUNCIONES PARA LOS TITULOS DE LOS PERROS */
  callGetAllDogTitles({
    commit
  }) {
    const prm = new Promise((resolve, reject) => {
      dogService.getAllDogTitles()
        .then(res => {
            console.log(res)
            return resolve(res);
          },
          error => {
            return reject(error);
          });
    });
    return prm;
  },

  /* FUNCION PARA INSERTAR UN NUEVO TITULO A UN PERRO */
  callInsertDogTitle({
    commit
  }, data) {

    const promesa = new Promise((resolve, reject) => {
      dogService.insertDogTitle(data)
        .then(
          res => {
            return resolve(res);
          },
          error => {
            return reject(error);
          })
    });
    return promesa;
  },

  callDeleteDogTitle({
    commit
  }, data) {
    const promesa = new Promise((resolve, reject) => {
      dogService.deleteDogTitle(data)
        .then(res => {
            return resolve(res);
          },
          error => {
            return reject(error);
          })

    });
    return promesa;

  }
}

const getters = {
  getLocalDogBreeds: (state) => state.dogBreeds,
  getLocalDogBooks: (state) => state.dogBooks,
  getCurrentEditDog: (state) => state.currentEditDog
}

const mutations = {

  statusLoading(state, status) {
    state.loading = status;
  },

  getDogBreedsOk(state, breeds) {
    state.dogBreeds = breeds;
    state.loading = false;
  },
  getDogBreedsKo(state) {
    state.dogBreeds = null;
    state.loading = false;

  },
  getUserDogByIdOk(state, dog) {
    console.log('desde el getUserDogByIdOk data', dog)
    state.currentEditDog = dog;
    state.loading = false;
  },
  getUserDogByIdKo(state, error) {
    state.error = error;
    state.loading = false;
  },

  /**
   *  dog books
   */
  getBooksRequest(state) {
    state.dogBooks = {
      loading: true
    };
  },
  getBooksSuccess(state, books) {
    state.dogBooks = books;
  },
  getBooksFailure(state, error) {
    state.dogBooks = {
      error
    };
  },
  /**
   * DOGS CRUD
   */
  createDogRequest(state, dog) {
    state.loading = true;
  },
  createDogOk(state, dog) {
    state.dogsData = dog;
    state.loading = false;
  },
  createDogKo(state, error) {
    state.dogsData = null;
    state.error = error;
    state.loading = false;
  },
  updateDogOk(state, dog) {
    state.dogsData = dog;
    state.loading = false;
    // const id = dog.data.id
    // var pDog = state.current.data.dogs.find(dogs => dogs.id === id)
    // dogs.data.birth_date = dogs.data.birth_date.date
    // TODO: 04/08/2019 MANEJAR FECHAS
    // dogs.data.birth = moment(String(dogs.data.birth_date)).format('DD/MM/YYYY')
    // Object.assign(dog, dogs.data)
  },
  updateDogKo(state, error) {
    state.dog.error = error;
  },
  deleteDogSuccess(state, id) {
    state.current.data.dogs = state.current.data.dogs.filter(dog => dog.id !== id)
  },
}

export const dog = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}